import { render, staticRenderFns } from "./radio-input.vue?vue&type=template&id=08b3df2c&scoped=true&"
import script from "./radio-input.vue?vue&type=script&lang=ts&"
export * from "./radio-input.vue?vue&type=script&lang=ts&"
import style0 from "./radio-input.vue?vue&type=style&index=0&id=08b3df2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3df2c",
  null
  
)

export default component.exports